import { createView } from "@cloudextend/common/routes";

export const root = createView("");
export const home = createView("home");
